import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "32", "height": "32", "viewBox": "0 0 32 32", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "&#231;&#163;&#168;&#231;&#154;&#174;" } }, [_c("g", { attrs: { "id": "Group 48097291" } }, [_c("g", { attrs: { "id": "Group 48097256" } }, [_c("circle", { attrs: { "id": "Ellipse 348", "cx": "16", "cy": "16", "r": "11.8", "stroke": "#4F586B", "stroke-width": "2" } }), _c("path", { attrs: { "id": "Vector 187", "d": "M16 1.06665V30.9333", "stroke": "#4F586B", "stroke-width": "2" } }), _c("path", { attrs: { "id": "Vector 190", "d": "M16 16H27.7333", "stroke": "#4F586B", "stroke-width": "2" } }), _c("path", { attrs: { "id": "Vector 191", "d": "M16 10.6666H26.6667", "stroke": "#4F586B", "stroke-width": "2" } }), _c("path", { attrs: { "id": "Vector 192", "d": "M16 21.3333H26.6667", "stroke": "#4F586B", "stroke-width": "2" } })])])])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const SmootherBeautyIcon = __component__.exports;
export {
  SmootherBeautyIcon as default
};
